import React, { createContext, useState, useContext } from 'react';

const TimeFilterContext = createContext();

export const useTimeFilter = () => useContext(TimeFilterContext);

export const TimeFilterProvider = ({ children }) => {
    const [timeQuery, setTimeQuery] = useState(null);

    return (
        <TimeFilterContext.Provider value={{ timeQuery, setTimeQuery }}>
            {children}
        </TimeFilterContext.Provider>
    );
};